import { Component, OnInit } from '@angular/core';
import { Sidebar2SubpanelStateService } from '../../sidebar2-subpanel-state.service';
import { Router } from '@angular/router';
import { RouterStateService } from '../../../../../core/routing/router-state.service';

@Component({
    selector: 'app-sidebar2-estimates-sub-menu',
    templateUrl: './sidebar2-estimates-sub-menu.component.html',
    standalone: false,
})
export class Sidebar2EstimatesSubMenuComponent implements OnInit {
    statuses = [];
    settingsFlag = 'NavigationV2Estimates';
    defaultRoute = '/estimates/list';
    templateActive = false;
    constructor(
        private subpanelService: Sidebar2SubpanelStateService,
        private router: Router,
        private routerStateService: RouterStateService
    ) {}

    ngOnInit() {
        this.getEstimateStatuses();
        if (this.routerStateService.currentRoute?.queryParams?.submenu === 'templates') this.showTemplates();
    }

    getHeaderLink() {
        if (this.routerStateService.currentRoute?.queryParams?.submenu !== 'templates') {
            this.showTemplates();
        }
    }

    showTemplates() {
        const destRoute = this.defaultRoute;
        const settingsFlagParams = { subpanel: 'true', submenu: 'templates', type: 'template' };
        const paramsToUse =
            settingsFlagParams && this.routerStateService.currentRoute?.queryParams?.submenu !== settingsFlagParams.submenu
                ? settingsFlagParams
                : this.routerStateService.currentRoute?.queryParams;
        const destParams = paramsToUse || {};
        this.templateActive = true;
        this.router.navigate([destRoute], { queryParams: destParams, queryParamsHandling: 'replace' });
    }

    getEstimateStatuses() {
        this.subpanelService.getEstimatesPromise().then((res) => {
            this.statuses = res;
        });
    }
}
